import { Station } from '@mi-front/core';

export function isTranscriptionEnabled(station: Station) {
  return Boolean(station.featuresConfig?.transcription?.enabled);
}
